// Costa Rica: todos los textos van en "usted" (ver glosario de localizaciones).
export default {
  errors: {
    doubleFa: {
      codeError: 'El código que indicó es inválido, inténtelo de nuevo',
    },
    googleNotAvailable: 'El acceso con Google aún no está disponible para esta cuenta. Para continuar, ingrese su contraseña',
    technicalFailure:
      'Estamos experimentando fallas técnicas ahora mismo. Intente de nuevo en un momento',
    accountCreation:
      'Hubo un error al crear su cuenta, revise que su correo sea correcto e inténtelo de nuevo.',
    login: {
      invalidCredentials: 'Usuario o clave inválida. ¡Inténtelo de nuevo!',
      accountLocked:
        'Su cuenta ha sido bloqueada por intentos fallidos, hemos <br/>enviado un correo con las instrucciones para restablecer su contraseña',
      googleNotEnabled:
        'Acceso con Google no habilitado. Ingrese con su contraseña y actívelo desde Seguridad.',
    },
  },
  emailSuggestion: {
    prefix: '¿Quiso decir',
  },
  passwordCriteria: {
    title: 'Su contraseña requiere:',
  },
  countrySelector: {
    title: 'País donde se encuentra su empresa',
  },
  notFound: {
    message:
      'Parece que la página a la que intenta acceder no está disponible por el momento. Por favor, regrese a la página de inicio o inténtelo de nuevo más tarde.',
  },
  login: {
    needHelp: '¿Necesita ayuda?',
    title: 'Ingrese a su cuenta',
    subtitle: 'Siga ganando tiempo y tranquilidad',
    form: {
      email: {
        placeholder: 'Ingrese su correo',
      },
      password: {
        placeholder: 'Ingrese su contraseña',
      },
      forgotPassword: '¿Olvidó su contraseña?',
      magicLinkButton: {
        tooltip: 'Reciba un link para ingresar sin contraseña.',
      },
    },
    footer: {
      dontHaveAccount: '¿Aún no tiene una cuenta?',
      signUp: 'Regístrese gratis',
      allProducts: 'Ingrese con las mismas credenciales a todos los productos de Alegra.',
    },
  },
  register: {
    titleAlliance: 'Cree su cuenta gratis',
    form: {
      email: {
        placeholder: 'Ingrese su correo',
      },
      password: {
        placeholder: 'Ingrese una contraseña',
      },
      coupon: {
        label: '¿Tiene un código promocional?',
        placeholder: 'Ingréselo aquí',
      },
      googleButton: 'Regístrese con Google',
      magicLinkButton: {
        label: 'Regístrese desde su correo',
        tooltip: 'Reciba un link para registrarse sin contraseña.',
      },
    },
    footer: {
      haveAccount: '¿Ya tiene una cuenta?',
      login: 'Inicie sesión',
    },
  },
  registerEducationAlliance: {
    title: '¡Aquí empieza su alianza educativa con Alegra! 🎓',
    form: {
      information: {
        description:
          'Si no pertenece a una alianza educativa o desea usar Alegra para su negocio, cree una cuenta ',
      },
    },
  },
  doubleFA: {
    subtitle: 'Incluya el código de 6 dígitos generado en su app de autenticación.',
    anotherOption: '¿Necesita otra opción para autenticarse?',
    backupCodeSubtitle: 'Use uno de sus códigos de respaldo para autenticarse.',
    unableToAuth: '¿Sigue sin poder autenticarse?',
  },
  passwordUpdate: {
    title: 'Mantenga su cuenta segura',
    subtitle:
      'Necesita actualizar su contraseña para reforzar su seguridad, enviamos a <b>{email}</b> los pasos para cambiarla e iniciar sesión.',
    subtitleNoProvider:
      'Necesita actualizar su contraseña para reforzar su seguridad. Enviamos a <b>{email}</b> los pasos para cambiarla e iniciar sesión, puede buscarlos en su bandeja de entrada o spam.',
    footer: '¿No recibió el correo?',
    footerContactUs: 'Contáctenos',
    modal: {
      title: '¿Necesita ayuda?',
      subtitle: 'Estas son las opciones de soporte disponibles para usted',
      form: {
        title: 'Envíenos un correo',
        text: 'Nuestra bandeja de entrada está disponible 24/7 para ayudarle con su solicitud.',
      },
      chat: {
        title: 'Hable con un agente por chat',
      },
      call: {
        title: 'Llame a un agente',
        text: 'Encuentre el número de soporte para su país, horario de atención y llámenos.',
      },
    },
  },
  magicLink: {
    login: {
      main: {
        title: '¡Ingrese desde su correo!',
        subtitle: 'Use un link mágico para ingresar sin contraseña.',
      },
      sended: {
        title: '¡Le enviamos un link mágico!',
        subtitle:
          'Búsquelo en su bandeja de entrada o revise si llegó a la carpeta de spam <br class="hidden md:block" /><b>{email}</b>',
      },
      resended: {
        title: '¡Reenviamos su link mágico!',
        titleMultipleTimes: 'Envió 5 links en la última hora',
        text: 'Podrá solicitar otro link en:',
        textTime:
          'Puede usar otro método para iniciar sesión o solicitar un nuevo link a las {time}',
      },
    },
    signup: {
      main: {
        title: '¡Regístrese desde su correo!',
        subtitle: 'Use un link mágico para registrarse sin contraseña.',
      },
      sended: {
        title: '¡Le enviamos un link mágico!',
        subtitle:
          'Búsquelo en su bandeja de entrada o revise si llegó a la carpeta de spam <br class="hidden md:block" /><b>{email}</b>',
      },
      resended: {
        title: '¡Reenviamos su link mágico!',
        titleMultipleTimes: 'Envió 5 links en la última hora',
        text: 'Podrá solicitar otro link en:',
        textTime: 'Puede usar otro método para registrarse o solicitar un nuevo link a las {time}',
      },
    },
    expired: {
      title: '¡Su link mágico caducó!',
      subtitle:
        'Tenga en cuenta que el tiempo de disponibilidad es de <b>30 minutos</b> y solo puede ser usado una vez.',
    },
    form: {
      email: {
        placeholder: 'Indique su correo electrónico',
      },
    },
  },
  recoverPassword: {
    request: {
      title: '¿No puede ingresar a su cuenta?',
      subtitle: 'Restablezca su contraseña',
      message:
        'Enviamos las instrucciones para <br/>restablecer su contraseña al correo<br/> <b>{email}</b>',
      footer: {
        haveAccount: '¿Aún no tiene una cuenta?',
      },
    },
    change: {
      title: 'Restablezca su contraseña',
      subtitle: 'Por favor, cree su nueva contraseña.',
      form: {
        answerOk: {
          subtitle: 'Lo llevaremos de vuelta a su cuenta.',
        },
      },
    },
  },
  validateIdentity: {
    request: {
      description: 'Por seguridad, seleccione una opción para confirmar su identidad.',
      options: {
        whatsapp: {
          placeholder: 'Le enviaremos un código de seguridad a su número de WhatsApp.',
        },
        email: {
          placeholder: 'Le enviaremos un código de seguridad a su correo electrónico principal.',
        },
      },
    },
    requestWhatsApp: {
      description: 'Ingrese los últimos 4 dígitos de su número de WhatsApp.',
    },
    otp: {
      title: 'Ingrese el código de seguridad',
      description: {
        whatsapp: 'Revise su WhatsApp e ingrese el código de 6 dígitos.',
        email: 'Revise el correo {email} e ingrese el código de 6 dígitos para continuar.',
      },
      errorCode: 'El código es incorrecto. Intente nuevamente o solicite uno nuevo.',
    },
    temporarilyBlocked: {
      description:
        'Por su seguridad, hemos suspendido el acceso después de 3 intentos fallidos. Por favor, contacte a soporte para ingresar a su cuenta.',
      options: {
        email: {
          label: 'Escríbanos por correo',
        },
        chat: {
          label: 'Hable con un agente',
          placeholder: 'Nuestro equipo le atenderá de lunes a viernes de {start} a {end}.',
        },
      },
      info: 'Este bloqueo es <b>temporal</b>. Su información sigue 100% protegida en Alegra.',
    },
  },
}
